import { render, staticRenderFns } from "./VideoDeleteModal.vue?vue&type=template&id=110b76bd&scoped=true&"
import script from "./VideoDeleteModal.vue?vue&type=script&lang=js&"
export * from "./VideoDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110b76bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('110b76bd')) {
      api.createRecord('110b76bd', component.options)
    } else {
      api.reload('110b76bd', component.options)
    }
    module.hot.accept("./VideoDeleteModal.vue?vue&type=template&id=110b76bd&scoped=true&", function () {
      api.rerender('110b76bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/Video/VideoDeleteModal.vue"
export default component.exports